export default __webpack_public_path__ + "static/media/september2024-1.b4e7c1c6.jpg";